var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.5H2C1.17157 8.5 0.5 9.17157 0.5 10V13C0.5 13.8284 1.17157 14.5 2 14.5H8V8.5ZM2 8C0.895431 8 0 8.89543 0 10V13C0 14.1046 0.89543 15 2 15H8.5V8H2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H22C23.1046 8 24 8.89543 24 10V13C24 14.1046 23.1046 15 22 15H16V8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8.5H16.5V14.5H22C22.8284 14.5 23.5 13.8284 23.5 13V10C23.5 9.17157 22.8284 8.5 22 8.5ZM16 8V15H22C23.1046 15 24 14.1046 24 13V10C24 8.89543 23.1046 8 22 8H16Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 8.5H8.5V14.5H15.5V8.5ZM8 8V15H16V8H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtons);
export default __webpack_public_path__ + "static/media/buttons.eddb2fb1e4299c84bedf5436a0f755e6.svg";
export { ForwardRef as ReactComponent };